import React, { useState, useRef, useEffect } from 'react';
import * as commonActions from 'app/actions/commons';
import { toastError } from 'app/utils/toastHelper';
import { updateComment } from 'app/requests/comments';
import { useTranslation } from 'next-i18next';
import { useDispatch } from 'react-redux';
import { Message } from 'types/chat';

interface CommentEditProps {
  onClose: () => void;
  comment: Message;
  updateComments: (newComment: Message) => void;
}

const CommentEdit: React.FC<CommentEditProps> = ({ comment, updateComments, onClose }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [commentText, setCommentText] = useState<string>(comment.content);
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (textareaRef.current) {
      const len = textareaRef.current.value.length;
      textareaRef.current.focus();
      textareaRef.current.setSelectionRange(len, len);
    }
  }, []);

  const handleUpdateComment = async () => {
    dispatch(commonActions.setLoading(true));
    try {
      const newComment = await updateComment(comment?.id || 0, commentText);
      updateComments(newComment);
      onClose();
    } catch (error) {
      toastError(error.message);
    } finally {
      dispatch(commonActions.setLoading(false));
    }
  }

  return (
    <div>
      <div className="d-md-flex align-items-center">
        <textarea
          className="form-control"
          rows={1}
          ref={textareaRef}
          placeholder={t('comments.enter_comment')}
          value={commentText}
          onChange={(e) => setCommentText(e.target.value)}
          style={{
            borderRadius: '8px',
            resize: 'none',
            boxShadow: 'inset 0 1px 3px rgba(0,0,0,0.05)',
            padding: '10px',
            fontSize: '1rem'
          }}
        />
          <button
            type="button"
            onClick={() => onClose()}
            className="btn btn-sm btn-secondary ml-md-2 ml-0 mt-md-0 mt-2"
          >
            {t('commons.cancel')}
          </button>
          <button
            type="button"
            onClick={() => handleUpdateComment()}
            className="btn btn-sm btn-info ml-2 mt-md-0 mt-2"
          >
            {t('actions.update')}
          </button>
      </div>
    </div>
  );
};

export default CommentEdit;
